export const DatePickerIcon = () => {
    return (
        <svg className="w-4 h-4 text-orange-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
            <path d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"/>
        </svg>
    )
}

export const CloseIcon = () => {
    return (
        <svg
            className="w-3 h-3"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 14 14"
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
            />
        </svg>
    )
}

interface DropDownArrowIconProps  {
    isOpen: boolean;
    color?: string;
}

export const DropDownArrowIcon = ({ isOpen, color }: DropDownArrowIconProps) => {
    return (
        <svg
            className={`w-[10px] h-[10px] md:w-[13px] md:h-[13px] transform transition-transform ${
            isOpen ? "rotate-180" : "rotate-0"
            } ${color}`}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 20 20"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
            />
        </svg>
    )
}

export default function LoadingCircle({ size = 50, color = '#4F46E5' }: { size?: number; color?: string }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 50 50"
            className="animate-spin"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle
                cx="25"
                cy="25"
                r="20"
                stroke={color}
                strokeWidth="5"
                fill="none"
                strokeLinecap="round"
                strokeDasharray="90 150"
            />
        </svg>
    );
}

export const ArrowUp = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-3 h-3 text-gray-400"
        >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 15l7-7 7 7" />
        </svg>
    )
}

export const ArrowDown = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            className="w-3 h-3 text-gray-400"
        >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
        </svg>
    )
}

type IconifyComponentProps = {
	color?: string;
	size?: string | number;
	className?: string;
}

export const Arrow = ({ color = 'currentColor', size = '1em', className }: IconifyComponentProps) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" className={className} width={size} height={size} style={{ color }} viewBox="0 0 24 24">
			<path d="M0 0h24v24H0z" fill="none" />
			<path fill={color} fillRule="evenodd" d="m4 15l8-8l8 8l-2 2l-6-6l-6 6z" />
		</svg>
	)
}